import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Hero from "./components/Sections/Hero";
import VehicleList from "./components/Sections/VehicleList";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import { I18nProvider } from "./i18n";

const PREFIX_LANGS = ["en", "de", "it", "es", "pt"];

function Home() {
  const [dateRange, setDateRange] = useState({ from: "", to: "" });



  return (
    <>
      <Hero dateRange={dateRange} setDateRange={setDateRange} />
      <div id="vehicules">
        <VehicleList dateRange={dateRange} />
      </div>
    </>
  );
}

function NotFound() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>404</h1>
      <p>Page non trouvée.</p>
    </div>
  );
}

function LangTree({ lang }) {
  return (
    <I18nProvider forcedLang={lang}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="reserver" element={<Contact />} />
          <Route path="legal" element={<Legal />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </I18nProvider>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        {PREFIX_LANGS.map((lang) => (
          <Route key={lang} path={`/${lang}/*`} element={<LangTree lang={lang} />} />
        ))}
        <Route path="/*" element={<LangTree lang="fr" />} />
      </Routes>
    </Router>
  );
}